import { EnvironmentProviders, makeEnvironmentProviders, ModuleWithProviders, NgModule } from '@angular/core';
import defaultsDeep from '@df/util/fn/defaults-deep';
import { DeepPartial } from '@df/util/type/deep-partial';
import { NDfAccount } from './df-account.config';

const providers = (config?: DeepPartial<NDfAccount.IModuleOptions>) => [
    {
        provide: NDfAccount.OPTIONS,
        useFactory: () => {
            return defaultsDeep(config || {}, NDfAccount.DEFAULT_CONFIG);
        }
    }
];

@NgModule()
export class DfAccountModule {
    static forRoot(config?: DeepPartial<NDfAccount.IModuleOptions>): ModuleWithProviders<DfAccountModule> {
        return {
            ngModule: DfAccountModule,
            providers: providers(config)
        };
    }
}

/**
 * Use in Angular 18+
 */
export function provideDfAccount(config?: DeepPartial<NDfAccount.IModuleOptions>): EnvironmentProviders {
    return makeEnvironmentProviders(providers(config));
}